export * from './singleSignOn/singleSignOn.component';